import { Container } from "@pixi/display";
import { GameUIResourcesPackage } from "../../../../preloader/resources/GameUIResourcesPackage";
import { FigureData } from "../../../models/figure/FigureData";
import { SquareView } from "../square/SquareView";
import { DeckFigureView } from "./DeckFigureView";
import { TriangleView } from "../triangles/TriangleView";

export class UltimateFigureView extends DeckFigureView {

    public constructor(
        figureData: FigureData,
        squares: Array<SquareView>,
        private readonly gameResources: GameUIResourcesPackage
    ) {
        super(figureData, squares);
        this.getAllTriangles(this).forEach(triangle => {
            triangle.playUltimateAnimation();
        });
    }

    private getAllTriangles(container: Container): Array<TriangleView> {
        let triangles = new Array<TriangleView>();
        for (let child of container.children) {
            if (child instanceof TriangleView) {
                triangles.push(child);
            }
            if (child instanceof Container) {
                triangles = triangles.concat(this.getAllTriangles(child));
            }
        }
        return triangles;
    }
}
